import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.flag)?_c(VBtn,{staticClass:"ml-1 mr-2",attrs:{"small":"","color":"primary"},on:{"click":function($event){return _setup.download()}}},[_vm._v("\n  Exportação Dunorte\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }